import config from "../../config/config.json";
import { headers } from "../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
  cancelPreviousRequest,
  decryptResponse
} from "../../APIHelpers/Responses";

export const noteServices = {
  addNewNote,
  updatedNote,
  deleteNote,
  getNoteList,
  getSingleNote
};

// Add New Note
async function addNewNote(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewNote`,
    headersWithAuth("POST", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Update Note
async function updatedNote(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updatedNote`,
    headersWithAuth("PUT", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Delete Note
async function deleteNote(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteNote`,
    headersWithAuth("DELETE", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Get All Note
async function getNoteList(contactId) {
  try {
    const signal = cancelPreviousRequest(`getNoteList`);
    let apiURL = `${config.API_URL_USER_ONBOARDING}getNoteList/${contactId}`
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", headers),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if(data?.statusCode === 401){
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get Single Note
async function getSingleNote(contactId, noteId) {
  try {
    const signal = cancelPreviousRequest(`getSingleNote`);
    let apiURL = `${config.API_URL_USER_ONBOARDING}getSingleNote/${contactId}/${noteId}`
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", headers),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if(data?.statusCode === 401){
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}